const styles = (theme) => ({
  profileAvatar: {
    width: '128px',
    height: '128px',
    border: `2px solid ${theme.palette.background.main}`,
  },
  profileAvatarError: {
    border: `2px solid ${theme.palette.error.main}`,
    color: `${theme.palette.error.main}`,
  },
  buttonAvatar: {
    width: '40px',
    height: '40px',
    border: `2px solid ${theme.palette.background.secondary}`,
    backgroundColor: theme.palette.primary.main,
  },
  spinner: {
    color: theme.palette.secondary.main,
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: 1,
  },
});

export default styles;
